<template>
  <div class="service-card-container">
    <div class="card-container">
      <div
        v-for="(item, i) in listOfServices"
        :key="i"
        class="card wow fadeIn delay-1s"
      >
        <div>
          <h2>
            {{ item.title[getIndex()] }}
          </h2>
          <h4 v-if="$i18n.locale === 'ar'" style="font-family: englishfont;">
            {{ titles[i] }}
          </h4>
          <p>{{ item.body[getIndex()] }}</p>
        </div>
        <div>
          <img :src="getImage(item.image)" alt="service" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ServiceCard",
  data() {
    return {
      titles: [
        "Website",
        "Mobile Application",
        "Database",
        "Domain",
        "Hosting",
        "Network"
      ]
    };
  },
  computed: mapGetters(["listOfServices"]),
  methods: {
    getIndex() {
      let lang = this.$i18n.locale;
      if (lang === "ku") return 0;
      else if (lang === "ar") return 1;
      else return 2;
    },
    getImage(name) {
      return require("../../assets/" + name);
    }
  }
};
</script>

<style lang="scss" scoped>
.service-card-container {
  width: 65%;
  margin: auto;
  position: relative;
  z-index: 2;
}
.card-container {
  margin: auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 200px 0px;
}
.card:not(:last-child) {
  margin-bottom: 100px;
}

.card {
  width: 30%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.card p {
  padding: 25px 0px;
  opacity: 0.8;
}
.card img {
  display: block;
  width: 50px;
  margin: auto;
}

@media (max-width: 768px) {
  .card-container {
    padding: 100px 0px;
  }
  .service-card-container {
    width: 75%;
  }
  .card {
    width: 45%;
    margin-bottom: 50px;
  }
  .card:nth-child(1),
  .card:nth-child(2),
  .card:nth-child(3) {
    margin-bottom: 50px;
  }
  .card h2 {
    font-size: 20px;
  }
  .card img {
    margin-bottom: 25px;
  }
}

@media (max-width: 525px) {
  .service-card-container {
    width: 90%;
  }
  .card {
    width: 100%;
  }
}
</style>
